<template>
    <v-dialog v-model="dialogVisible" max-width="600px" @click-outside="applySettings">
        <v-card class="greenheader">
            <v-card-title class="cardtitle"> Select Tone of Voice </v-card-title>
            <v-card-subtitle class="cardsubtitle"> Here you can select the tone of voice for the content generation. You can also add or remove custom tones. </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" class="py-0">
                            <v-radio-group v-model="assignmentMethod" row @change="changeSettings">
                                <!-- Option 1: Automatische Zuordnung -->
                                <v-radio value="preset" class="radio-option">
                                    <template v-slot:label>
                                        <div class="option-content" style="width: 100%">
                                            <strong>Select Tone of Voice </strong>
                                            <p class="mb-0" style="font-size: 14px">Choose from a predefined list of tonalities.</p>
                                        </div>
                                    </template>
                                </v-radio>

                                <!-- Option 2: Manuelle Zuordnung -->
                                <v-radio value="custom" class="radio-option">
                                    <template v-slot:label>
                                        <div class="option-content">
                                            <strong>Custom Brand Voice </strong>
                                            <p class="mb-0" style="font-size: 14px">Create a custom tone of voice for your brand by entering example text.</p>
                                        </div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-slide-x-transition hide-on-leave>
                        <v-row v-if="assignmentMethod === 'preset'">
                            <v-select
                                v-model="preset_tone_of_voice"
                                @change="changeSettings"
                                :items="presetTones"
                                label="Select Tone of Voice"
                                rounded
                                filled
                                clearable
                                clear-icon="mdi-close"
                                type="select"></v-select>
                        </v-row>
                    </v-slide-x-transition>
                    <v-slide-x-transition hide-on-leave>
                        <v-row v-if="assignmentMethod === 'custom'">
                            <v-btn v-if="user_settings.cs_prompts.prompts && user_settings.cs_prompts.prompts.length" class="ml-auto" text color="primary" @click="showHistory = !showHistory">
                                <v-icon> {{ showHistory ? "mdi-chevron-up " : "mdi-chevron-down" }}</v-icon> browse history</v-btn
                            >

                            <v-col cols="12" v-if="showHistory">
                                <v-select
                                    id="history"
                                    width="500px"
                                    ref="combobox"
                                    @change="changeSettings"
                                    v-model="hist_tone_of_voice"
                                    :items="user_settings.cs_prompts.prompts"
                                    label="Browse history"
                                    item-text="text"
                                    clearable
                                    filled
                                    rounded>
                                    <template v-slot:selection="{ item }">
                                        <span>{{ truncateText(item.text, 100) }}</span>
                                    </template>

                                    <template v-slot:item="{ item }">
                                        <v-list-item three-line @click="selectPrompt(item)">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    ><v-chip small>{{ formatDate(item.created_at) }}</v-chip></v-list-item-title
                                                >
                                                <v-list-item-subtitle style="white-space: wrap !important">{{ truncateText(item.text, 300) }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn icon color="primary"> <v-icon small @click.stop="deletePrompt(item)">mdi-delete</v-icon></v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </template>
                                </v-select>
                                <!-- <v-combobox
                                    filled
                                    ref="combobox"
                                    v-model="tone_of_voice"
                                    :items="user_settings.cs_prompts.prompts"
                                    label="Browse history"
                                    rounded
                                    item-text="text"
                                    clearable
                                    @change="savePrompt"
                                    v-bind:search-input.sync="searchValue"
                                    auto-grow>
                                    <template v-slot:item="{ item, index }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on: itemOn, attrs: itemAttrs }">
                                                <v-list-item
                                                    three-line
                                                    @mouseenter="hoverIndex = item"
                                                    @mouseleave="hoverIndex = null"
                                                    @click.native="selectPrompt(item)"
                                                    v-bind="itemAttrs"
                                                    v-on="itemOn">
                                                    <v-list-item-content>
                                                        <v-list-item-title class="multiline-text">{{ truncateText(item.text, 100) }}</v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-fade-transition>
                                                            <v-icon v-if="hoverIndex === item" @click.stop="deletePrompt(item)"> mdi-close </v-icon>
                                                        </v-fade-transition>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </template>
                                            <span>{{ item.text }}</span>
                                        </v-tooltip>
                                    </template>
                                </v-combobox> -->
                            </v-col>
                            <v-col cols="12" class="mt-0">
                                <v-textarea
                                    id="brandvoicearea"
                                    rounded
                                    filled
                                    @focus="prompAnalyzed = false"
                                    @blur="savePrompt(tone_of_voice)"
                                    color="primary"
                                    hint="Insert at least one full sentence"
                                    label="Insert a text to analyze..."
                                    placeholder="Insert a text to analyze... "
                                    :counter="{
                                        props: {
                                            max: 500,
                                            value: 0
                                        }
                                    }"
                                    v-model="tone_of_voice.text">
                                    <template v-slot:append>
                                        <div class="pl-2">
                                            <v-btn small v-if="prompAnalyzed" disabled color="primary" rounded outlined class="px-2">
                                                <v-icon small class="mr-1">mdi-check-circle</v-icon> analyzed</v-btn
                                            >
                                            <v-btn small v-if="analyzePrompt" disabled color="primary" rounded outlined
                                                ><v-progress-circular size="20" width="2" indeterminate color="primary"></v-progress-circular
                                            ></v-btn>
                                        </div>
                                    </template>
                                    <div style="position: relative"><v-icon style="position: absolute; left: 0">mdi-check</v-icon></div>
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-slide-x-transition>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="red" @click="closeDialog">Cancel</v-btn>
                <v-btn text color="green" @click="applySettings">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ContentGeneratorSettingsDialog",
        props: {
            value: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                hist_tone_of_voice: { text: null },
                analyzePrompt: false,
                prompAnalyzed: false,
                showHistory: false,
                preset_tone_of_voice: null,
                presetTones: [
                    "Friendly",
                    "Professional",
                    "Casual",
                    "Formal",
                    "Persuasive",
                    "Informative",
                    "Humorous",
                    "Inspirational",
                    "Conversational",
                    "Concise",
                    "Descriptive",
                    "Empathetic",
                    "Optimistic",
                    "Assertive",
                    "Playful",
                    "Sincere",
                    "Confident",
                    "Creative",
                    "Direct",
                    "Engaging",
                    "Motivational",
                    "Nostalgic",
                    "Sarcastic",
                    "Sympathetic",
                    "Thoughtful",
                    "Witty",
                    "Whimsical",
                    "Charming"
                ],
                assignmentMethod: "preset",
                dialogVisible: this.value,
                tone_of_voice: { text: null },
                hoverIndex: null,
                searchValue: ""
            }
        },
        computed: {
            user_settings: {
                get: function () {
                    if (!this.$store.state.user_settings.cs_prompts) this.$store.state.user_settings.cs_prompts = { prompts: [], selectedIndex: 0, preset: null }
                    console.log("usersettings ", this.$store.state.user_settings)

                    return this.$store.state.user_settings
                }
            }
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            },
            dialogVisible(val) {
                this.$emit("input", val)
            }
        },
        methods: {
            formatDate(date) {
                if (!date) return ""
                let d = new Date(date)
                return d.toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" })
            },
            truncateText(text, maxLength) {
                if (!text) return ""
                let textcopy = text + ""
                return textcopy.length > maxLength ? textcopy.substring(0, maxLength) + "..." : textcopy
            },
            async analyzeTonalaty(text) {
                console.log(text)

                if (!text || !text.text) {
                    return
                }
                this.analyzePrompt = true
                // const url = process.env.VUE_APP_APIURL + "/v2/sources/tonality-analyzer"
                // let post_data = {
                //     company_id: localStorage.company_id,
                //     text: text.text
                // }
                // let response_data = await this.$helpers.axiosPost(url, post_data)
                setTimeout(() => {
                    this.prompAnalyzed = true
                    this.analyzePrompt = false

                    return ""
                }, 500)
            },
            changeSettings() {
                if (this.assignmentMethod === "preset") {
                    this.user_settings.cs_prompts.selectedIndex = -1
                    this.user_settings.cs_prompts.preset = this.preset_tone_of_voice
                } else {
                    this.user_settings.cs_prompts.preset = null
                    this.user_settings.cs_prompts.selectedIndex = this.user_settings.cs_prompts.prompts.findIndex((p) => p.text === this.tone_of_voice.text)
                }
                let tone = this.assignmentMethod === "preset" ? this.preset_tone_of_voice : this.tone_of_voice
                this.$emit("generate", { tone_of_voice: tone })
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.user_settings)
            },
            closeDialog() {
                this.dialogVisible = false
            },
            applySettings() {
                let tone = this.assignmentMethod === "preset" ? this.preset_tone_of_voice : this.tone_of_voice
                this.$emit("generate", { tone_of_voice: tone })
                this.dialogVisible = false
            },
            selectPrompt(item) {
                this.tone_of_voice = item
                this.changeSettings()
                this.$nextTick(() => {
                    if (this.$refs.combobox) {
                        this.$refs.combobox.isMenuActive = false
                    }
                })
            },
            deletePrompt(prompt) {
                const index = this.user_settings.cs_prompts.prompts.indexOf(prompt)
                if (index > -1) {
                    if (this.user_settings.cs_prompts.prompts[index] === this.tone_of_voice) {
                        this.tone_of_voice = ""
                    }
                    this.user_settings.cs_prompts.prompts.splice(index, 1)
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.user_settings)
                }
            },
            async savePrompt(prompt) {
                if (!prompt || !prompt.text) {
                    return
                }
                let respData = await this.analyzeTonalaty(prompt)
                let promptData = { text: prompt.text ? prompt.text : prompt, analysis: respData, created_at: new Date() }
                this.selectPrompt(promptData)
                this.changeSettings()
                const index = this.user_settings.cs_prompts.prompts.findIndex((p) => p.text === prompt.text)
                if (index === -1) {
                    this.user_settings.cs_prompts.prompts.unshift(promptData)
                }
                this.user_settings.cs_prompts.selectedIndex = index === -1 ? 0 : index
                this.$store.dispatch("CHANGE_USER_SETTINGS", this.user_settings)
            }
        },
        mounted() {
            this.tone_of_voice = this.user_settings.cs_prompts.prompts[this.user_settings.cs_prompts.selectedIndex] || { text: null }
            if (this.tone_of_voice) this.prompAnalyzed = true
            if (this.user_settings.cs_prompts.preset || this.user_settings.cs_prompts.selectedIndex === -1) {
                this.assignmentMethod = "preset"
                this.preset_tone_of_voice = this.user_settings.cs_prompts.preset
            } else {
                this.assignmentMethod = "custom"
            }
        }
    }
</script>

<style scoped>
    .headline {
        font-weight: bold;
    }
    .radio-option:hover {
        background-color: #f0f0f0;
        border-radius: 8px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    /* Hover-Effekt für die Option-Text */
    .radio-option .option-content:hover strong {
        color: #000000; /* Ändert die Textfarbe beim Hover */
        transition: color 0.3s ease;
    }
    .radio-option {
        padding: 15px;
    }
    /* Abstände zwischen den Radio-Optionen und den Labels */
    .option-content {
        margin-left: 10px;
    }
    .multiline-text {
        white-space: normal; /* Erlaubt Zeilenumbrüche */
        word-wrap: break-word; /* Bricht lange Wörter um */
        overflow: hidden; /* Verhindert Überlauf */
        display: -webkit-box; /* Unterstützt Zeilenbegrenzung */
        -webkit-line-clamp: 2; /* Begrenze auf 2 Zeilen */
        -webkit-box-orient: vertical; /* Vertikale Ausrichtung für Zeilenbegrenzung */
    }
    #history .v-menu__content {
        max-width: 600px !important;
    }
</style>
